import React, { useEffect, useState } from "react";
import { RunnerUpHeader } from "../../../ui";
import SelectField from "../../../library/components/Select/index";
import { useGetEpbDownloadPhasewiseEciReportMutation } from "../../../services/reportsServices";
import "./countingsupervisoreciofficer.css";
import { Validators } from "../../../library/utilities/Validator";
import { downloadExcelFile, downloadPdfFile } from "../../utilities/utils"
import pdfIcon from "../../../images/pdfIcon.png"
import excelIcon from "../../../images/excelIcon.png"
import Table from "../../../ui/datatable/DataTable";
import LeftMenu from "../../AnalyticsModule/Left";
import MultiSelectCheckBox from "../../../ui/multiSelectCheckbox/MultiSelectCheckBox";
import RunnerUpHeaderNew from "../../../ui/runnerUpHeader/RunnerUpHeaderNew";

const tableHeader = [
  "State Name",
  "Phase No",
  "Total e-PB Generated",
  "Total e-PB Downloaded",
  "Total e-PB Pending for Download",
];

const phaseList = [];

const EpbStatusPhaseWise = () => {
  const [totalNoOfRecords, setTotalNoOfRecords] = useState()
  const reportName = "e-Postal Ballot Downloading Report Phase Wise"
  const SheetName = "State Wise Report"

  const [Error, setError] = useState({});
  // const { data: getElectionAnnouncedState } = useGetStatesStatusForceWiseQuery();
  const [tableData, setTableData] = useState([]);
  const [selected, setSelected] = useState([]);
  // const stateList = [{value: "", label: " Select State" }];
  const constType = [
    { value: "", label: "Select Constituency" },
    { value: "AC", label: "AC" },
    { value: "PC", label: "PC" },
  ];
  const tableHeader = [];
  const columns = [
    {
      Header: "State Name",
      accessor: "col1",
    },
    {
      Header: "Phase No",
      accessor: "col2",
    },
    {
      Header: "Total e-PB Generated",
      accessor: "col3",
    },
    {
      Header: "Total e-PB Downloaded",
      accessor: "col4",
    },
    {
      Header: "Total e-PB Pending for Download",
      accessor: "col5",
    },
  ];
  columns.map((item)=>{
    tableHeader.push(item.Header)
  })

  useEffect(()=>{
    const Phases = JSON.parse(localStorage?.phaseList)
    Phases.map((item)=>{
     phaseList.push({value:item, label:item})
    })
 
   },[])

  const [states, setStates] = useState({
    stateValue:"",
    constTypeValue:"",
  });

  const [saveData, datap] = useGetEpbDownloadPhasewiseEciReportMutation()

  // getElectionAnnouncedState?.payload?.map((item) => {
  //   stateList?.push({
  //     value: item.stateCd,
  //     label: item.stateName,
  //   });
  // });

  const handleChange = (key, value) => {
    setStates((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const getError = (key, value) => {
    let error = { ...Error };
    if (value && value.message) {
      setError({ ...Error, [key]: value.message });
    } else {
      delete error[key];
      setError(error);
    }
  };

  const renderTableData = () => {
    let error = {};
    if (!selected || selected.length === 0) {
      error["phaseList"] = "This field is required";
    }
    if (!states.constTypeValue || states.constTypeValue === "") {
      error["constTypeValue"] = "This Field is required"
    }
    if (Object.keys(error).length) {
      setError(error);
      return;
    }

    const data = [];
    selected.map((item) => data.push(item.value));

    let payload = {
      "stateCd": data,
      "constType": states.constTypeValue
    }
    

    saveData(payload)
      .unwrap()
      .then((res) => {
        let tData = []
        res?.payload?.map((item) => {
          tData.push({
            "col1": item.stateName,
            "col2": item.phaseNo,
            "col3": item.generatedEpb,
            "col4": item.downloadedEpb,
            "col5": item.pendingEpb,
          });
        });
        setTableData(tData)
        setTotalNoOfRecords(res?.payload?.length)
      }).catch((error) => {
        if(error?.data?.message==="No record found")
        {
          
          setTableData([])
        }
      })
  };
  return (
    <>
    <LeftMenu>
      <div className="container box shadow ">
      <div className="row">
          <div className="col-md-12">
            <RunnerUpHeaderNew title={reportName} 
            onPdfClick={() => downloadPdfFile(`e-Postal Ballot Downloading Report Phase Wise (${states.constTypeValue})`, tableHeader, tableData , false, true)}
            onExcelClick={() => downloadExcelFile(`e-Postal Ballot Downloading Report Phase Wise (${states.constTypeValue})`, SheetName, tableHeader, tableData, true)}
          />
          </div>
        </div>
        <div className="row">
        <div className="col-md-2" style={{paddingRight:"0px"}}><p style={{textAlign:"right",paddingTop:"6px"}}>Select Phase</p></div>
          <div className="col-md-4">
            <MultiSelectCheckBox
              options={phaseList}
              name="phaseList"
              value={selected}
              className={"col-md-12"}
              onChange={setSelected}
              labelledBy="Select"
              validators={[
                {
                  check: Validators.required,
                  message: "This field is required",
                },
              ]}
              getError={(val) => getError("phaseList", val)}
              Error={Error}
            ></MultiSelectCheckBox>
          </div>
          <SelectField
            labelClass=""
            inputClass="col-md-2 pr-1"
            value={states.constTypeValue}
            name="constTypeValue"
            handleChange={(val) => handleChange("constTypeValue", val)}
            options={constType}
            validators={[
              {
                check: Validators.required,
                message: "This field is required",
              }
            ]}
  
            getError={(val) => getError("constTypeValue", val)}
            Error={Error}
          />
          <div className="col-md-2 ">
          <button
              type="button"
              className="btn btn-primary btn-sm searchbuttonreport"
              onClick={renderTableData}>
              VIEW
              <span className="pl-2">
                <i class="fa fa-eye">
                </i>
              </span>
            </button>
          </div>
        </div>
        <div style={{marginTop:"0px"}}>
        <Table
              placeholder="Search"
              globalsearch={true}
              selectall={true}
              columns={columns}
              emptyMessage="No Record Found"
              data={tableData?.length === 0 ? [] : tableData}
              size={5}
              tableClassNameCheck="contenttable-eroll"
              pagination  
              records
              gotopage
              rows
              numberrows={totalNoOfRecords}
            />
        </div>
      </div>
      </LeftMenu>
    </>
  );
};

export default EpbStatusPhaseWise;
